import { type LeadQualificationQuestion } from "../../types/lead.types.ts"

/** The approved default question set. Lived in the wizard's
 * `LeadDetailsVerificationChecklist` until 2026-08-30, when that component
 * lost its last renderer and was deleted — the workspace card here is the
 * only surface that still reads these. */
export const verificationChecklist: LeadQualificationQuestion[] = [
  {
    question: "Property Classification",
    answer: ""
  },
  {
    question: "Duration of Ownership",
    answer: ""
  },
  {
    question: "When did you begin considering this project?",
    answer: ""
  },
  {
    question: "How may we best support you throughout this journey?",
    answer: ""
  },
  {
    question:
      "Many homeowners explore several options before proceeding. Have you received any estimates to date?",
    answer: ""
  },
  {
    question: "Existing Estimates (if available)",
    answer: ""
  },
  {
    question: "How many firms are you currently considering for this project?",
    answer: ""
  },
  {
    question: "What is your preferred timeline for this project?",
    answer: ""
  }
]

/**
 * The wizard no longer seeds the approved set, so a lead created through it
 * carries `null`/`undefined` — never touched — and falls back to the same
 * constant. An explicit `[]` is different: it means the user deleted every
 * configured question on purpose (2026-08-30 qualification add/delete), and
 * must read back as genuinely empty rather than resurrecting the defaults.
 */
const leadQualificationQuestions = (
  questions?: LeadQualificationQuestion[] | null
): LeadQualificationQuestion[] =>
  questions == null ? verificationChecklist : questions

const isAnswered = (question?: LeadQualificationQuestion | null) =>
  !!question?.answer?.trim()

const answeredQualificationCount = (
  questions?: LeadQualificationQuestion[] | null
): number => (questions ?? []).filter(isAnswered).length

const hasQualificationAnswers = (
  questions?: LeadQualificationQuestion[] | null
): boolean => answeredQualificationCount(questions) > 0

export {
  answeredQualificationCount,
  hasQualificationAnswers,
  isAnswered,
  leadQualificationQuestions
}
